export default {
    computed: {
        size() {
            const settings = this.$store.getters.getSettings;
            return settings.size;
        }
    }
};
